import axios from 'axios';

export const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use(async (config) => {
    const shopify = (window as any).shopify;
    if (shopify && typeof shopify.idToken === 'function') {
        try {
            const token = await shopify.idToken();
            if (config.headers && token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
        } catch (e) {
            console.warn("Shopify idToken failed", e);
        }
    }
    return config;
});
